const bodyContainer = document.querySelector(".body-container");
const modals = document.querySelectorAll(".site-modal");

if (modals) {
  modals.forEach((modal) => {
    const modalThanksBlock = modal.querySelector("#modal_thanks");
    const modalFormBlock = modal.querySelector("#modal_form");
    const modalVideo = modal.querySelector("iframe");
    const modalTitle = modal.querySelector(".site-modal__title");
    const modalDescription = modal.querySelector(".site-modal__description");
    const hiddenInput_1 = modal.querySelector("#type");
    const hiddenInput_2 = modal.querySelector("#hidden_item_name");
    const hiddenInput_3 = modal.querySelector("#page_link");
    const hiddenInput_4 = modal.querySelector("#form_type");
    const onModalClose = (evt) => {
      evt.stopPropagation();
      if (
        evt.target.matches(
          ".site-modal__close-button, .site-modal__content-container"
        )
      ) {
        bodyContainer.classList.remove("body-container--no-scroll");
        modal.classList.remove("site-modal--opened");
        if (modalTitle) {
          modalTitle.innerText = "";
        }
        if (modalDescription) {
          modalDescription.innerText = "";
        }
        if (modalThanksBlock) {
          modalThanksBlock.classList.remove(
            "message-form__thanks-wrapper--visible"
          );
          modalFormBlock.style.display = "block";
        }
        if (modalVideo) {
          modalVideo.src = "";
        }
        if (hiddenInput_1) {
          hiddenInput_1.value = "";
        }
        if (hiddenInput_2) {
          hiddenInput_2.value = "";
        }
        if (hiddenInput_3) {
          hiddenInput_3.value = "";
        }
        if (hiddenInput_4) {
          hiddenInput_4.value = "";
        }
      }
    };
    document.addEventListener("click", onModalClose);
  });
}
